import { Button, FormLabel, HStack, Spacer } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { DisciplineSelector } from "./DisciplineSelector";
import { Discipline_GET } from "../../../Api/dto/Discipline_GET";
import { DragAndDropExcelWithSignups } from "./Step1_5DragAndDropExcel";
import { SignupRequest } from "../../../Api/dto/SignupRequest_POST";
import { SignupUnit } from "./SignupFlow";
import { Role, useSessionState } from "../../../Session/SessionService";

export function SelectItem(props: {
  startState: number | null;
  onNext: (disciplineId: number) => void;
  onParseSignupsFromFile: (signups: Array<SignupUnit>) => void;
  disciplines: Discipline_GET[];
  competitionStartTime: Date;
}) {
  const [selectedDiscipline, setSelectedDiscipline] =
    useState<null | Discipline_GET>(null);
  const session = useSessionState();

  useEffect(() => {
    const discipline = props.disciplines.filter(
      (d) => d.id == props.startState
    );
    if (discipline.length > 0) {
      setSelectedDiscipline(discipline[0]);
    }
  }, []);

  return (
    <>
      <FormLabel>Klass</FormLabel>
      <DisciplineSelector
        eventStart={props.competitionStartTime}
        disciplines={props.disciplines}
        onSelect={(d: Discipline_GET[]) => {
          if (d.length > 0) {
            setSelectedDiscipline(d[0]);
          } else {
            setSelectedDiscipline(null);
          }
        }}
        selectLimit={1}
        initialSelections={props.disciplines.filter(
          (d) => d.id === selectedDiscipline?.id
        )}
        showDeleted={false}
        preventSelectionOfClosedSignup={true}
      />
      {session.hasUserMode(Role.DEVELOPER) && (
        <DragAndDropExcelWithSignups
          onParseFailure={() => {}}
          onParsedSignups={(data: Array<SignupUnit>) => {
            props.onParseSignupsFromFile(data);
          }}
          selectedDiscipline={selectedDiscipline}
        />
      )}
      <HStack marginTop={"20px"}>
        <Spacer />
        <Button variant="ghost" visibility={"hidden"} mr={3} type="button">
          Tillbaka
        </Button>
        <Button
          colorScheme="pink"
          type="submit"
          disabled={selectedDiscipline == null}
          isDisabled={selectedDiscipline == null}
          onClick={() => {
            if (selectedDiscipline) {
              props.onNext(selectedDiscipline.id);
            }
          }}
        >
          Nästa
        </Button>
        <Spacer />
        <Spacer />
      </HStack>
    </>
  );
}
